import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import './theme/design-system.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.register();
